import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const notificationsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Pages',
    url: '#!'
  },
  {
    label: 'Notifications',
    active: true
  }
];
